<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Đăng ký yêu cầu đặt phòng khách sạn
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên yêu cầu" prop="requestName">
              <el-input
                v-model="form.requestName"
                placeholder="Tên yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="100"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Nội dung yêu cầu" prop="requestContent">
              <el-input
                type="textarea"
                v-model="form.requestContent"
                placeholder="Nội dung yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <hc-ks-upload
              ref="hcMaybayUpload"
              :hcCaseFlightFileType="
                HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.TO_TRINH
              "
            ></hc-ks-upload>
          </el-col>

          <el-col :span="24">
            <hc-ks-users ref="hcMaybayUsers"></hc-ks-users>
          </el-col>

          <el-col :span="24">
            <hc-ks-places ref="hcKsPlaces"></hc-ks-places>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Gửi yêu cầu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import hcCaseHotelService from "../../../services/khachsan/hcCaseHotelService";
  import uploadFileMixin from "../../doc-in/uploadFileMixin";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
  import CustomDialog from "../../common/custom-dialog";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import hcFlowService from "../../../services/hcFlowService";
  import constants from "../../../constants";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import h from "../../../services/h";
  import HcMaybayUpload from "../vemaybay/hc-maybay-upload";
  import HcKsPlaces from "./hc-ks-places";
  import HcKsUsers from "./hc-ks-users";
  import HcKsUpload from "./hc-ks-upload";

  export default {
    name: "hc-ks-create-dialog",
    mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
    props: ["isOpen"],
    components: {
      HcKsPlaces,
      HcKsUpload,
      HcKsUsers,
      HcMaybayUpload,
      CustomDialog
    },

    data() {
      return {
        rules: {
          requestName: null,
          requestContent: null,
          flightFileList: null,
          flightUserList: null,
          flightRouteList: null
        },
        form: {
          requestName: null,
          requestContent: null,
          flightFileList: [],
          flightUserList: [],
          flightRouteList: []
        },
        hcFlow: null,
        HC_CASE_FLIGHT_FILE: constants.HC_CASE_FLIGHT_FILE,
        toTrinhValidateFileOptions: null,
        flowCode: constants.HC_FLOW.FLOW_CODE.KHACH_SAN
      };
    },

    computed: {},

    watch: {},

    created() {
      this.initValidationRules();
      this.initMayBayFileValidateFileOptions();
      this.loadHcFlow();
    },

    methods: {
      initMayBayFileValidateFileOptions() {
        this.toTrinhValidateFileOptions = hanhChinhUtils.initMayBayFileValidateFileOptions(
          constants.HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH
        );
      },

      loadHcFlow() {
        return hcFlowService
          .getHcFlowAlternative(this.flowCode)
          .then(response => {
            this.hcFlow = response.data;
            this.flowId = this.hcFlow.id;
          });
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        this.rules.requestName = [defaultRequiredConstrains];
        this.rules.requestContent = [defaultRequiredConstrains];
      },

      validateUploadFiles() {
        return new Promise(resolve => {
          let files = this.$refs.hcMaybayUpload.getData();
          if (!files || !files.length) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcMayBay.files.required"})
            );
          } else {
            resolve();
          }
        });
      },

      validateUsers() {
        return new Promise(resolve => {
          let files = this.$refs.hcMaybayUsers.getData();
          if (!files || !files.length) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcHotel.users.required"})
            );
          } else {
            resolve();
          }
        });
      },

      validatePlaces() {
        return new Promise(resolve => {
          let hotels = this.$refs.hcKsPlaces.getData();
          if (!hotels || !hotels.length) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcHotel.hotels.required"})
            );
          } else {
            resolve();
          }
        });
      },

      validateForm() {
        return new Promise(resolve => {
          this.$refs.form.validate(valid => {
            if (!valid) {
              this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
            } else {
              resolve();
            }
          });
        });
      },

      convertToSubmitForm() {
        let users = h.collect(this.$refs.hcMaybayUsers.getData(), user => {
          return {
            userName: user.userName,
            email: user.email,
            gender: user.gender,
            birthday: user.birthday,
            isdn: user.isdn,
            identityNumber: user.identityNumber,
            positionId: user.positionId,
            deptId: user.deptId,
            checker: user.isCheckIn ? constants.TRUE : constants.FALSE
          };
        });

        let hotels = h.collect(this.$refs.hcKsPlaces.getData(), place => {
          return {
            locationId: place.location,
            hotelId: place.hotel,
            checkIn: place.checkIn,
            checkOut: place.checkOut,
            countRoom1: place.countRoom1,
            countRoom2: place.countRoom2
          };
        });

        return {
          flowId: this.hcFlow ? this.hcFlow.id : null,
          requestName: this.form.requestName,
          requestContent: this.form.requestContent,
          files: this.$refs.hcMaybayUpload.getData(),
          users: users,
          hotels: hotels
        };
      },

      submit() {
        this.validateForm()
          .then(() => this.validateUploadFiles())
          .then(() => this.validateUsers())
          .then(() => this.validatePlaces())
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            console.log(JSON.stringify(submitForm));
            return hcCaseHotelService
              .create(submitForm)
              .then(response => response.data);
          })
          .then(hcCaseFlight => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "hcCaseHotel.insertSuccess"
              })
            );
            this.$emit("insertSuccess", {result: hcCaseFlight});
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      }
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-create-dialog.vue